export default class RelationshipModel {
    id: string | null;
    label: string | null;

    constructor(id: string | null, label: string | null) {
        this.id = id;
        this.label = label;
    }

    static fromApiResponse(data: any): RelationshipModel {
        return new RelationshipModel(
            data.id_parentesco || null,
            data.parentesco || null
        );
    }

    static fromApiResponseArray(dataArray: any[]): RelationshipModel[] {
        return dataArray.map(data => RelationshipModel.fromApiResponse(data));
    }
}
